import languages from './Languages'
import jQuery from 'jquery'

export default class LanguageSelector {

  constructor() {
    jQuery(document).on('click', '.selected-lang-wrapper',
      event => {
        let langMenu = jQuery(event.target).parents('.lang-menu')
        this.toggleLangList(langMenu[0])
      }
    )
  }

  initAll() {
    const langMenuList = document.querySelectorAll('.lang-menu')
    langMenuList.forEach(langMenu => {
      this.init(langMenu)
    })
  }

  init(langMenu) {
    if (!langMenu) {
      return
    }

    let $defaultLangEl = langMenu.querySelector('.selected-lang')
    let $langList = langMenu.querySelector('.available-languages-list')
    const documentLang = document.documentElement.lang
    $defaultLangEl.innerText = documentLang
    let listItems = []
    for (let langObj of languages) {
      if (langObj.lang == documentLang.toLowerCase()) {
        continue
      }
      listItems.push(`<li><a onclick='location.assign("../${langObj.lang}" + location.hash)'>${langObj.title}</a></li>`)
    }
    $langList.innerHTML = listItems.join('')
  }

  toggleLangList(langMenu) {
    langMenu.querySelector('.lang-list-wrapper').classList.toggle('open')
  }
}